import { FabricException } from '../models/fabric-exception.js';
import {
  addExceptionHandlingMiddleware,
  isFabricException,
  useException,
  useExceptionGlobal,
} from './exception.js';

export const exception = {
  useException,
  useExceptionGlobal,
  isFabricException,
  addExceptionHandlingMiddleware,
  FabricException,
};
